/* EXAMPLE
{
    "actions": [
        {
            "at": "multi",
            "data": {
                "p": "24",
                "m": "3",
                "total": [ "3", "3", "3", "3", "9" ]
            }
        }
    ],
    "reelSet": "fs",
    "stops": [ "27", "62", "25", "51", "18" ],
    "grid": "--./+*))1/,,1+----*,)/+)*05"
}
*/
import { gridToSymbols } from '@aceroll/platform-hacksaw';
import { platform } from "../..";


export default function (data) {
    const parsed = {
        reelSet: data.reelSet,
        stops: data.stops,
        symbols: gridToSymbols(data.grid),
        actions: data.actions && data.actions.length ? data.actions.map((action) => { return platform.stateActionParser.parse(action); }) : []
    };
    return parsed;
}

